export enum BRAND {
	Mango = 'mango',
	Mng = 'mng',
}
